import { render } from "./TodaySales.vue?vue&type=template&id=62997346&scoped=true"
import script from "./TodaySales.vue?vue&type=script&lang=js"
export * from "./TodaySales.vue?vue&type=script&lang=js"

import "./TodaySales.vue?vue&type=style&index=0&id=62997346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62997346"]])

export default __exports__